import Loader from '../Loader/Loader'

const Achievements = () => {
  return (
    <>
      <Loader active={false} />
      <div className="container mx-auto mt-10">
        <div className="flex flex-col">
          <div className="flex justify-left text-3xl text-blackOlive px-8 pb-2">
            Achievements
          </div>
          <p className="flex justify-left text-sm text-blackOlive px-8 pb-2">
            Achievements will show here
          </p>
        </div>
      </div>
    </>
  )
}

export default Achievements
